export default import.meta.ROLLUP_FILE_URL_zs7Fs4P5;